export { CrmOpportunityPageActionsComponent } from './opportunity-page-actions.component';
export { CrmOpportunityStatusBadgeComponent } from './opportunity-status-badge.component';
